import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './i18n';
import StandAloneApp from '@/stand-alone-app/StandAloneApp';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <StandAloneApp />
  </React.StrictMode>,
);
